<div *ngIf="loadingContent === true" [@inOutAnimation] class="loader -wrapper"></div>

<div *ngIf="loadingContent" [@inOutAnimation] class="loader -parent">
  <div class="loader -circle"></div>
  <div class="loader -line--mask">
    <div class="loader -line"></div>
  </div>
  <!-- <img src="/assets/images/icon.svg"/> -->
</div>